import type { IIconProps } from "@fluentui/react/lib/Icon";
import { getRTL, memoizeFunction } from "@fluentui/react/lib/Utilities";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { HighContrastSelector } from "@fluentui/react";

const cachedIconProps = memoizeFunction(
  (
    iconName: string,
    iconColor?: string,
    hideIcon?: boolean,
    flip?: boolean,
    disabled?: boolean
  ): IIconProps => {
    // We need to set the color and fill attribute because some teams rely on it for their icon coloring
    return {
      iconName,
      ...((iconColor || hideIcon || flip || disabled) && {
        styles: {
          root: {
            ...(iconColor && { color: iconColor, fill: iconColor }),
            ...(hideIcon && { visibility: "hidden" }),
            ...(flip && {
              "-webkit-transform": "scaleX(-1)",
              transform: "scaleX(-1)",
            }),
            ...(disabled && {
              opacity: 0.4,
              selectors: {
                [HighContrastSelector]: {
                  opacity: 1,
                },
              },
            }),
          },
        },
      }),
    };
  }
);

export const iconNameToIconProps = (
  iconName?: string,
  iconColor?: string,
  hideIcon?: boolean,
  flipInRtl?: boolean,
  disabled?: boolean,
  shouldFlipIcon?: boolean
): IIconProps | undefined => {
  const isRTL = getRTL();
  return iconName
    ? cachedIconProps(
        iconName,
        iconColor,
        hideIcon,
        (flipInRtl && isRTL) || shouldFlipIcon,
        disabled
      )
    : undefined;
};
